import React from 'react';
export const LegalFooter = () => {
  return <footer className="w-full bg-be-navy py-12 px-4 border-t border-white/10" data-id="element-126">
      <div className="max-w-3xl mx-auto text-center space-y-6" data-id="element-127">
        <p className="text-white/40 text-[10px] sm:text-xs leading-relaxed" data-id="element-128">
          *$150 credit valid only on first visit back at Be Clinical and applied
          toward services booked at the time of your complimentary consultation.
          Minimum service spend of $500 required to redeem credit. Credit cannot
          be combined with other offers, has no cash value, and is
          non-transferable. Offer expires Sunday at midnight. Treatments subject
          to provider assessment and medical eligibility.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-white/50 text-xs" data-id="element-129">
          <span data-id="element-130">© 2026 Be Clinical. All rights reserved.</span>
          <div className="hidden sm:block w-1 h-1 rounded-full bg-white/20" data-id="element-131"></div>
          <div className="flex gap-4" data-id="element-132">
            <a href="#" className="hover:text-white transition-colors" data-id="element-133">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-134">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
};